import { FC } from 'react';

import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useUITranslation } from '@pp/core/src/services/uiTranslations/reactBindings/hooks';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

export const CrashHelpChapterIntroduction: FC = () => {
  const tableName = useConfigSlice.tableName() ?? '';
  if (!tableName) return null;
  const tName = useUITranslation(tableName) ?? tableName;

  return (
    <div>
      <p>
        <HelpText dynamicValues={{ TABLE_NAME: tName }} tk="introduction.gameDescription" markdown />
      </p>

      <p>
        <HelpText tk="introduction.gameObjective" markdown />
      </p>

      <p>
        <HelpText tk="introduction.joinGame" />
      </p>
    </div>
  );
};
